/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';

import './card.less';
import { ReactComponent as EditIcon } from '../../../assets/icons/editBtn.svg';
import { icons } from '../../pages/create-group-type/create-group-type.page';
import { ReactComponent as GroupTypeIcon } from '../../../assets/icons/groupType1.svg';
import { iconNames } from '../../../store/modules/facility/i-facility';

type ICard = {
  onClick: (e:React.MouseEvent<HTMLDivElement, MouseEvent>) => void,
  onDetailsClick?:(e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  data?: {name?:string, value?:string | number, id?:string|number}[]
  title?:string,
  id?:number | string,
  region?:string,
  icon: iconNames | null,
};

const Card = ({
  onClick,
  onDetailsClick,
  data,
  title,
  region,
  icon,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  id,
}:ICard) : JSX.Element => {
  const Icon = icon ? icons[icon].icon : GroupTypeIcon;
  return (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className="card"
      onClick={onClick}
    >
      <div className={`card__wrapper ${data
        ? 'card__wrapper-expandable' : ''}`}
      >
        <div className="card__header">
          <div className="card__container">
            <Icon className="groupType-card__img" />
          </div>
          <div className="card__text-container">
            {region && <h5 className="card__region">{region}</h5>}
            <h4 className="card__title">{title}</h4>
          </div>
          <button type="button" className="card__btn" onClick={onDetailsClick}>
            <EditIcon />
          </button>
        </div>

        <div className="card__data">
          {data && data.map(((field) => (
            <div className="card__field field" key={field.id}>
              <p className="field__column">
                <span className="field__key">{field.name}</span>
              </p>
              <p className="field__column field__value">
                <span>{field.value}</span>
              </p>
            </div>
          )))}
        </div>

      </div>
    </div>

  );
};

export default Card;
